export enum RegexPatterns {
  UtmParameter = '^[a-zA-Z0-9-]+$'
}
